// extracted by mini-css-extract-plugin
export var boldText = "_70-4";
export var checkboxContainer = "_70-6";
export var closeIcon = "_70-i";
export var container = "_70-0";
export var drawer = "_70-8";
export var drawerContent = "_70-9";
export var extraSmallText = "_70-5";
export var fulfillmentGroupTable = "_70-e";
export var largeText = "_70-3";
export var loadingSpinnerContainer = "_70-j";
export var mediumText = "_70-2";
export var narrow = "_70-f";
export var notificationLink = "_70-l";
export var packageCheckIconContainer = "_70-7";
export var slideoutHeaderActions = "_70-g";
export var slideoutHeaderActionsShifted = "_70-h";
export var slideoutHeaderContainer = "_70-a";
export var slideoutModal = "_70-c";
export var stickyHeaderWrapper = "_70-b";
export var table = "_70-k";
export var tableContainer = "_70-d";
export var tertiaryText = "_70-1";